import { ValidatorFn } from '@angular/forms';

export enum FieldTypes {
  Textbox = 'input',
  InputGroup = 'inputgroup',
  FileUpload = 'file',
  FilePathUpload = 'filepath',
  Password = 'password',
  Email = 'email',
  Number = 'number',
  Date = 'date',
  Time = 'time',
  TextArea = 'textarea',
  RadioList = 'radiolist',
  Select = 'select',
  Search = 'search',
  Checkbox = 'checkbox',
  CheckboxList = 'checkboxlist',
  Button = 'button',
  ButtonGroup = 'buttongroup',
  Link = 'link',
}

export interface Field {
  config: IFieldConfig;
}
export interface IFieldConfig {
  name: string;
  label?: string;
  errorLabel?: string;
  cancelButtonLabel?: string;
  disabled?: boolean;
  options?: FieldOption[];
  placeholder?: string;
  type: FieldTypes;
  cssClass?: string;
  focus?: boolean;
  validation?: ValidatorFn[];
  value?: any;
  hidden?: boolean;
  tooltip?: string;
  clicked?: boolean;
  additionalText?: string;
  onSubmit?: (...args: unknown[]) => void;
  onCancel?: () => void;
  errorMessages?: Record<string, string>;
  inputGroupAddOnLabel?: string;
  inputGroupAddOnHandler?: (...args: unknown[]) => void;
  onSelectChange?: (...args: unknown[]) => void;
  clickHandler?: (...args: unknown[]) => void;
  rows?: number;
}

export interface FieldOption {
  value: string | number;
  text: string;
  selected?: boolean;
}
